// File: /src/services/apiClient.js

import axios from 'axios';
import { AuthError, handleLogout, isTokenValid } from '../utils/auth';

export const API_BASE_URL =
	process.env.REACT_APP_API_BASE_URL ||
	(process.env.NODE_ENV === 'production'
		? 'https://api.locatime.com.br/api'
		: 'http://localhost:5000/api');

const apiClient = axios.create({
	baseURL: API_BASE_URL,
});

let logoutHandler = null;
let isHandlingUnauthorized = false;

const resolveAuthToken = () => {
	const token = localStorage.getItem('authToken');

	if (!token) {
		return null;
	}

	if (!isTokenValid(token)) {
		handleLogout();
		throw new AuthError('Token de autenticação expirado.');
	}

	return token;
};

apiClient.interceptors.request.use(
	(config) => {
		try {
			const token = resolveAuthToken();
			if (token) {
				config.headers = {
					...config.headers,
					Authorization: `Bearer ${token}`,
				};
			}
		} catch (error) {
			if (error instanceof AuthError) {
				return Promise.reject(error);
			}
		}

		return config;
	},
	(error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error?.response?.status === 401 && !isHandlingUnauthorized) {
			isHandlingUnauthorized = true;
			try {
				if (logoutHandler) {
					logoutHandler();
				} else {
					handleLogout();
				}
			} finally {
				isHandlingUnauthorized = false;
			}
		}

		return Promise.reject(error);
	},
);

export const setApiClientLogoutHandler = (handler) => {
	logoutHandler = handler;
};

export default apiClient;
